const domain: string = 'ALERT'

export const SAVE_ALERT: string = `${domain}/SAVE_ALERT`
